import React from 'react';
import { FilledTextFieldProps, TextFieldProps } from '@mui/material/TextField';
import { MuiDatePicker } from './mui-date-picker';

import './date-picker.scss';

export type DatePickerValue = Date | string | undefined;

export interface IDatePickerProps {
  value: DatePickerValue;
  onChange: (date: DatePickerValue) => void;
  name?: string;
  className?: string;
  label?: FilledTextFieldProps['label'];
  minDate?: Date;
  maxDate?: Date;
  openToDate?: Date;
  error?: boolean;
  errorText?: React.ReactNode | Date;
  warningText?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  inlineDisplay?: boolean;
  // Validators are functions that return ether "undefined"=invalid or any value=valid.
  // Validators are executed in the order they are specified until a validator returns a value other than "undefined".
  // If all validators return undefined then the value is considered invalid.
  validators?: Array<(value: string) => DatePickerValue>;
  invalidDateMessage?: string;
  showTimeSelect?: boolean | undefined;
  fullWidth?: boolean;
  variant?: TextFieldProps['variant'];
  helperText?: TextFieldProps['helperText'];
  onCalendarOpen?(): void;
  onCalendarClose?(): void;
  onInternalValidation?(failiureCause: string | undefined): void;
  enableRelativeDateFormatting?: boolean;
  disableAutoOpen?: boolean;
  shouldDisableDate?: (date: Date) => boolean;
}

export function DatePicker(props: IDatePickerProps) {
  const {
    value,
    onChange,
    name,
    className,
    label,
    minDate,
    maxDate,
    openToDate,
    required,
    readOnly,
    error,
    errorText,
    disabled,
    inlineDisplay,
    warningText,
    validators,
    invalidDateMessage = 'Indtast en gyldig dato',
    variant = 'filled',
    showTimeSelect,
    helperText,
    fullWidth,
    onCalendarOpen,
    onCalendarClose,
    onInternalValidation,
    enableRelativeDateFormatting = false,
    disableAutoOpen,
    shouldDisableDate,
  } = props;

  return (
    <MuiDatePicker
      value={value}
      onChange={onChange}
      name={name}
      className={className}
      label={label}
      minDate={minDate}
      maxDate={maxDate}
      openToDate={openToDate}
      error={error}
      errorText={errorText}
      warningText={warningText}
      disabled={disabled}
      readOnly={readOnly}
      required={required}
      inlineDisplay={inlineDisplay}
      validators={validators}
      invalidDateMessage={invalidDateMessage}
      showTimeSelect={showTimeSelect}
      fullWidth={fullWidth}
      variant={variant}
      helperText={helperText}
      onCalendarOpen={onCalendarOpen}
      onCalendarClose={onCalendarClose}
      onInternalValidation={onInternalValidation}
      enableRelativeDateFormatting={enableRelativeDateFormatting}
      disableAutoOpen={disableAutoOpen}
      shouldDisableDate={shouldDisableDate}
    />
  );
}
